import * as els from './halfPageManagerElements';

let windowWidth = window.innerWidth;

// JS nastavení aside prvků pro reklamy přes celou výšku
// Nefunguje nastavení přes CSS, protože grid dopředu neví, kolik bude mít řádků
export const halfPageManagerRowExtender = (): void => {
  // Top aside bloku upravujeme CSS jen pokud existuje
  if (els.topAside) {
    const topContentElementRowHeights: string = getComputedStyle(
      els.topContent as HTMLElement
    ).getPropertyValue('grid-template-rows');
    const topRowCount: number = topContentElementRowHeights
      .split(' ')
      .filter((val) => val.trim() !== '0px' && val.trim() !== '')
      .length + 1;

    if (windowWidth > 1080) els.topAside.style.setProperty('display', 'block');
    else els.topAside.style.setProperty('display', 'none');
    els.topAside.style.setProperty('grid-row-end', topRowCount.toString(10));
  }

  // Bottom aside bloku upravujeme CSS jen pokud existuje
  if (els.bottomAside) {
    const bottomContentElementRowHeights: string = getComputedStyle(
      els.bottomContent as HTMLElement
    ).getPropertyValue('grid-template-rows');
    const bottomRowCount: number = bottomContentElementRowHeights.split(' ').length + 1;

    if (windowWidth > 1080) els.bottomAside.style.setProperty('display', 'block');
    else els.bottomAside.style.setProperty('display', 'none');
    els.bottomAside.style.setProperty('grid-row-end', bottomRowCount.toString(10));
  }
};

window.addEventListener('resize', () => {
  windowWidth = window.innerWidth;
  halfPageManagerRowExtender();
});
